import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import { LEAVE_STATUS_COLORS, LEAVE_STATUS_LABELS } from '../constants';

const LeaveStatusBadge = ({ status }) => (
  <Chip label={LEAVE_STATUS_LABELS[status] || status} color={LEAVE_STATUS_COLORS[status] || 'default'} size="small" />
);

LeaveStatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
};

export default LeaveStatusBadge;
